import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Menu, MenuItem, IconButton, Hidden, Drawer, Divider } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Help from '@material-ui/icons/HelpRounded';
import Warning from '@material-ui/icons/WarningRounded';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import defaultLogo from './assets/logo.svg';
import defaultSmallLogo from './assets/logo_small.svg';
import PropTypes from 'prop-types';
import HSpacer from './HSpacer';
import Button from './Button';
import MenuIcon from '@material-ui/icons/Menu';
import List from './List';
import ListItem from './ListItem';

var styles = function styles(theme) {
  return {
    flex: {
      flexGrow: 1
    },
    navBar: {
      backgroundColor: '#58606A'
    },
    container: {
      boxShadow: 'none'
    },
    root: {
      color: 'white',
      height: '64px'
    },
    white: {
      color: 'white'
    },
    tabLabel: {
      fontSize: '16px'
    },
    clickable: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    uppercase: {
      textTransform: 'uppercase'
    }
  };
};

function capitalized(text) {
  if (typeof text === typeof 'abc' && text.length > 0) {
    return text[0].toUpperCase();
  }

  return undefined;
}

var TopBar =
/*#__PURE__*/
function (_Component) {
  _inherits(TopBar, _Component);

  function TopBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TopBar);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TopBar)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      anchorEl: null,
      drawerOpen: false
    }, _this.handleClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    }, _this.handleClose = function () {
      _this.setState({
        anchorEl: null
      });
    }, _this.handleUserAction = function (action) {
      _this.handleClose();

      _this.handleTrack(action.event || action.name);

      action.actionHandler && action.actionHandler();

      _this.setState({
        drawerOpen: false
      });
    }, _this.handleTrack = function (event) {
      var mixpanel = _this.props.mixpanel;

      if (mixpanel && typeof mixpanel.track === typeof function () {
        return 1;
      }) {
        mixpanel.track(event);
      }
    }, _this.toggleDrawer = function () {
      _this.setState({
        drawerOpen: !_this.state.drawerOpen
      });
    }, _temp));
  }

  _createClass(TopBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          anchorEl = _this$state.anchorEl,
          drawerOpen = _this$state.drawerOpen;
      var _this$props = this.props,
          classes = _this$props.classes,
          title = _this$props.title,
          tabActions = _this$props.tabActions,
          userActions = _this$props.userActions,
          buttonActions = _this$props.buttonActions,
          help = _this$props.help,
          helpCallback = _this$props.helpCallback,
          isLogged = _this$props.isLogged,
          userInfo = _this$props.userInfo,
          currentTab = _this$props.currentTab,
          titleClickAction = _this$props.titleClickAction,
          logo = _this$props.logo,
          smallLogo = _this$props.smallLogo,
          transparent = _this$props.transparent,
          asUser = _this$props.asUser;

      if (userActions && userActions.lenght !== 0 && (!userInfo || userInfo === undefined)) {
        console.warn('[SM-Components] User actions are defined in TopBar but no userInfo was provided');
      }

      return React.createElement(AppBar, {
        position: 'static',
        color: 'default',
        className: classes.container,
        style: transparent ? {
          backgroundColor: 'transparent'
        } : {}
      }, React.createElement(Hidden, {
        xsDown: true
      }, React.createElement(Toolbar, {
        className: transparent ? undefined : classes.navBar
      }, React.createElement('img', {
        src: logo || defaultLogo,
        onClick: titleClickAction,
        alt: 'Logo',
        style: {
          height: '48px'
        },
        className: classes.clickable
      }), React.createElement(Typography, {
        variant: 'h5',
        style: {
          color: 'white',
          paddingTop: '5px'
        }
      }, title), React.createElement(HSpacer, {
        large: true
      }), tabActions !== undefined && React.createElement(Tabs, {
        value: currentTab,
        indicatorColor: 'primary'
      }, tabActions.map(function (entry, index) {
        return React.createElement(Tab, {
          key: index,
          label: entry.label,
          classes: {
            root: classes.root,
            label: classes.tabLabel
          },
          onClick: function onClick() {
            return _this2.handleUserAction(entry);
          }
        });
      })), React.createElement('span', {
        className: classes.flex
      }), buttonActions !== undefined && buttonActions.map(function (action) {
        return React.createElement(React.Fragment, {
          key: action.name
        }, React.createElement(Button, {
          color: 'primary',
          variant: 'contained',
          onClick: function onClick() {
            return _this2.handleUserAction(action);
          }
        }, action.label), React.createElement(HSpacer, {
          small: true
        }));
      }), asUser && React.createElement(IconButton, null, React.createElement(Warning, {
        style: {
          color: 'red',
          width: '24px',
          height: '24px'
        }
      })), help && React.createElement(IconButton, {
        onClick: helpCallback
      }, React.createElement(Help, {
        style: {
          color: 'white',
          width: '24px',
          height: '24px'
        }
      })), React.createElement(HSpacer, {
        medium: true
      }), isLogged && userInfo !== undefined && React.createElement(React.Fragment, null, React.createElement(Avatar, {
        'aria-owns': anchorEl ? 'user-actions' : undefined,
        'aria-haspopup': 'true',
        onClick: this.handleClick,
        className: userActions !== undefined ? classes.clickable : undefined
      }, capitalized(userInfo.firstName), capitalized(userInfo.lastName)), userActions !== undefined && userActions.length !== 0 && React.createElement(Menu, {
        id: 'user-actions',
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: this.handleClose
      }, userActions.map(function (action) {
        return React.createElement(MenuItem, {
          key: action.name,
          onClick: function onClick() {
            return _this2.handleUserAction(action);
          }
        }, action.label);
      }))))), React.createElement(Hidden, {
        smUp: true
      }, React.createElement(Toolbar, {
        className: transparent ? undefined : classes.navBar
      }, React.createElement(IconButton, {
        color: 'inherit',
        'aria-label': 'Open drawer',
        onClick: this.toggleDrawer,
        className: classes.white
      }, React.createElement(MenuIcon, null)), React.createElement('img', {
        src: smallLogo || defaultSmallLogo,
        onClick: titleClickAction,
        alt: 'Logo',
        style: {
          height: '48px'
        },
        className: classes.clickable
      }), tabActions !== undefined && React.createElement(Typography, {
        variant: 'h5',
        style: {
          color: 'white',
          paddingTop: '5px',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        },
        className: classes.uppercase
      }, tabActions[currentTab].label)), React.createElement(Drawer, {
        open: drawerOpen,
        onClose: this.toggleDrawer
      }, React.createElement(List, null, tabActions !== undefined && React.createElement(React.Fragment, null, tabActions.map(function (entry, index) {
        return React.createElement(ListItem, {
          key: index,
          selected: index === currentTab,
          onClick: function onClick() {
            return _this2.handleUserAction(entry);
          }
        }, React.createElement(Typography, {
          variant: 'subtitle1',
          className: classes.uppercase
        }, entry.label));
      })), tabActions !== undefined && tabActions.length !== 0 && buttonActions !== undefined && buttonActions.length !== 0 && React.createElement(Divider, null), buttonActions !== undefined && buttonActions.map(function (action) {
        return React.createElement(ListItem, {
          key: action.name,
          onClick: function onClick() {
            return _this2.handleUserAction(action);
          }
        }, React.createElement(Typography, {
          variant: 'subtitle1',
          className: classes.uppercase
        }, action.label));
      }), (tabActions !== undefined && tabActions.length !== 0 || buttonActions !== undefined && buttonActions.length !== 0) && (help || isLogged && userInfo !== undefined && userActions !== undefined && userActions.length !== 0) && React.createElement(Divider, null), help && React.createElement(ListItem, {
        onClick: helpCallback
      }, React.createElement(Typography, {
        variant: 'subtitle1'
      }, 'Documentation')), isLogged && userInfo !== undefined && userActions !== undefined && userActions.length !== 0 && userActions.map(function (action) {
        return React.createElement(ListItem, {
          key: action.name,
          onClick: function onClick() {
            return _this2.handleUserAction(action);
          }
        }, React.createElement(Typography, {
          variant: 'subtitle1'
        }, action.label));
      })))));
    }
  }]);

  return TopBar;
}(Component);

var action = PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string,
  event: PropTypes.string,
  actionHandler: PropTypes.func
});
TopBar.propTypes = {
  title: PropTypes.string,
  // The main title of the product
  titleClickAction: PropTypes.func,
  isLogged: PropTypes.bool,
  // User is logged ?
  userActions: PropTypes.arrayOf(action),
  // An array of user actions (Placed below the user icon)
  tabActions: PropTypes.arrayOf(action),
  // An array of tabActions
  userInfo: PropTypes.any,
  // TODO: Need to define this object
  currentTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  help: PropTypes.bool,
  helpCallback: PropTypes.func
};
export default withStyles(styles)(TopBar);